import { formatQuantity, quotaUnitLabel } from '../../utils/inventoryLabels';

/**
 * The operating preferences a holder can switch, with what each position
 * means for the person reading the row.
 */
export const CLIENT_PREFERENCES = [
  {
    key: 'auto_reserve',
    label: 'Reservar al ingresar',
    on: 'Al entrar una orden se compromete el stock enseguida.',
    off: 'Las órdenes esperan como Ingresadas hasta que alguien las reserve.',
    onShort: 'al ingresar',
    offShort: 'cuando alguien la reserve',
  },
  {
    key: 'require_picking',
    label: 'Exigir picking',
    on: 'Despachar exige cada línea pickeada a mano, desde su ubicación.',
    off: 'Al despachar, el sistema pickea solo lo que falte. Nunca se salta el kardex.',
    onShort: 'pickeo a mano',
    offShort: 'pickeo automático al despachar',
  },
  {
    key: 'seller_can_reserve',
    label: 'Cliente reserva',
    on: 'El cliente reserva sus órdenes Ingresadas desde su panel. Solo reservar: no pickea, no prepara ni despacha.',
    off: 'Reservar lo hace quien opera la bodega.',
    onShort: 'el cliente puede reservar',
    offShort: 'reserva solo el operador',
  },
];

/** The quota as "500 posiciones", or a dash when the contract sets none. */
export const quotaLabel = (row) => {
  if (row?.quota === null || row?.quota === undefined) return '—';
  return `${formatQuantity(row.quota)} ${quotaUnitLabel(row.quota_unit) || ''}`.trim();
};

/**
 * What to say after switching a preference: the client's name and what its
 * orders will do from now on.
 */
export const preferenceDoneNotice = (row, key, value) => {
  const name = row.company?.name || 'El cliente';
  const messages = {
    auto_reserve: value
      ? `${name} vuelve a reservar al ingresar la orden`
      : `Las órdenes de ${name} van a esperar como Ingresadas`,
    require_picking: value
      ? `${name} vuelve a exigir picking a mano antes de despachar`
      : `Al despachar, las órdenes de ${name} se pickean solas`,
    seller_can_reserve: value
      ? `${name} ya puede reservar sus órdenes Ingresadas desde su panel`
      : `${name} deja de reservar: lo hace quien opera la bodega`,
  };
  return { type: 'success', message: messages[key] };
};

/** Why nothing can be switched on a row, or `null`. */
export const manageBlocker = (row) =>
  row?.can_manage ? null : 'Solo el titular de esta bodega define cómo se trabaja en ella';
